/** Point unique de libération des URL, y compris celles des aperçus et de l'impression. */
export function revoquerUrl(url: string): void {
  URL.revokeObjectURL(url)
}

/** Le dialogue « Enregistrer sous » peut rester ouvert plusieurs minutes (Brave). */
export function telecharger(contenu: BlobPart, nom: string, type = 'application/json'): void {
  const url = URL.createObjectURL(contenu instanceof Blob ? contenu : new Blob([contenu], { type }))
  // Un blob peut être privé : il ne survit ni à la page, ni à la session (déconnexion,
  // changement de compte ici ou dans un autre onglet).
  const jeton = (e: StorageEvent) => { if (e.key === 'lobster_token' || e.key === null) liberer() }
  const liberer = () => {
    clearTimeout(minuteur)
    window.removeEventListener('pagehide', liberer)
    window.removeEventListener('terobs:purge-session', liberer)
    window.removeEventListener('storage', jeton)
    revoquerUrl(url)
  }
  const minuteur = setTimeout(liberer, 600_000)
  window.addEventListener('pagehide', liberer, { once: true })
  window.addEventListener('terobs:purge-session', liberer, { once: true })
  window.addEventListener('storage', jeton)
  const lien = document.createElement('a')
  lien.href = url
  lien.download = nom
  lien.rel = 'noopener'
  lien.style.display = 'none'
  document.body.appendChild(lien)
  try { lien.click() } finally { lien.remove() }
}
